<template>
  <div class="dashboardAdmin-parentdiv bluebtn">
    <div
      class="
        dashboardAdmin-header
        d-flex
        justify-content-between
        align-items-center
        mt-4
      "
    >
      <div class="dashboardAdmin-header-main-head">
        <span>Job Dashboard</span>
      </div>
    </div>

    <div class="mt-3 w-100 common-body-container">
      <b-row>
        <template v-if="listView">
          <b-col cols="10">
            <div class="head-font">Allocated Recruiters</div>
            <div class="subhead-font mt-1">
              Simply drag and drop position IDs to reassign them to other
              recruiters
            </div>
          </b-col>
        </template>
        <template v-else>
          <b-col cols="10">
            <div class="head-font">Assigned Jobs</div>
            <div class="subhead-font mt-1">
              To update the position status, kindly click on the position ID.
            </div>
          </b-col>
        </template>
        <b-col cols="2" class="d-flex justify-content-end">
          <div class="d-flex common-switchParent">
            <div
              :class="
                !roles.includes('RECRUITER_VIEW') && 'disabled-kanban-img'
              "
              class="common-switchChild"
              @click="
                roles.includes('RECRUITER_VIEW') ? toggleSwitch(true) : ''
              "
              v-b-tooltip.hover.bottom="'Recruiter View'"
            >
              <img
                v-if="listView"
                src="../../assets/New-job-dashboard/recruiterView-selected.svg"
                alt=""
              />

              <img
                v-else
                src="../../assets/New-job-dashboard/recruiterView-unselected.svg"
                alt=""
              />
            </div>

            <div
              :class="!roles.includes('JOB_VIEW') && 'disabled-kanban-img'"
              class="common-switchChild"
              @click="roles.includes('JOB_VIEW') ? toggleSwitch(false) : ''"
              v-b-tooltip.hover.bottom="'Job View'"
            >
              <img
                v-if="!listView"
                src="../../assets/New-job-dashboard/jobView-selected.svg"
                alt=""
              />

              <img
                v-else
                src="../../assets/New-job-dashboard/jobView-unselected.svg"
                alt=""
              />
            </div>
          </div>
        </b-col>
      </b-row>

      <div>
        <RecruiterView v-if="listView" />
        <JobView v-else />
      </div>
    </div>
  </div>
</template>

<script>
import RecruiterView from "../../views/JobDashboard/RecruiterView.vue";
import JobView from "../../views/JobDashboard/JobView.vue";
import { mapGetters } from "vuex";

export default {
  name: "JobDashboard",
  components: {
    RecruiterView,
    JobView,
  },
  data() {
    return {
      listView: true,
    };
  },
  mounted() {
    if (
      this.$route.query.status === "recruiterview" ||
      (this.roles.includes("RECRUITER_VIEW") && !this.$route.query.status)
    ) {
      this.listView = true;
    } else {
      this.listView = false;
    }
    this.toggleSwitch(this.listView);
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  methods: {
    toggleSwitch(value) {
      this.listView = value;
      this.$router.push({
        name: "JobDashboard",
        query: {
          status: this.listView ? "recruiterview" : "jobview",
        },
      });
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped></style>
